window.dataLayer = window.dataLayer || [];

if (!window.customElements.get('buy-box')) {
  class BuyBox extends HTMLElement {
    constructor() {
      super();
      this.product = {
        title: this.dataset.title,
        sku: this.dataset.sku,
        id: this.dataset.id,
        price: parseInt(this.dataset.price)
      };

      this.sellingPlans = Array.from(this.querySelectorAll('input[name="selling_plan"]'));
    }

    setPlan () {
      const search = window.location.search;
      if (search.indexOf('plan=') === -1) return;
      const plan = 'selling_plan_' + search.split('plan=')[1].split('&')[0];
      const target = document.getElementById(plan);
      if (target) {
        target.checked = true;
        this.setVariant({ target });
      }
    }

    getPlan (form) {
      return this.sellingPlans
        .filter((plan) => plan.closest('form') === form)
        .find((plan) => plan.checked);
    }

    getPrice () {
      const checked = this.getPlan();
      return parseInt(checked ? checked.dataset.price : this.product.price);
    }

    addToCart (form) {
      const plan = this.getPlan(form);
      const formData = {
        'items': [{ 
          'id': form.id.value,
          'quantity': 1,
          'selling_plan': plan ? plan.value : ''
        }] 
      };

      Shopify.addItemFromData(formData, function() {
          Shopify.runPromotions();
          Shopify.showCart(true);
      })
    }

    setVariant ({ target }) {
      if (!target) return;
      var variantId = target.dataset.variantId;
      this.querySelector('input[name="id"]').value = variantId;
    }

    addEvents () {
      this.addEventListener('submit', (e) => {
        e.preventDefault();
        this.addToCart(e.target);
      })

      /* variant swap */
      var sellingPlanInputList = [].slice.call(this.querySelectorAll('input[name="selling_plan"]'))
      sellingPlanInputList.map(function (sellingPlanInputEle) {
         sellingPlanInputEle.addEventListener('change', this.setVariant.bind(this));
      }.bind(this));

    }
    
    connectedCallback() { /* add to cart lives in cart.shopify.js */
      this.setPlan();
      this.addEvents();
    }
  }

  window.customElements.define('buy-box', BuyBox);
}
